import { axiosInstance, handleApiRequest } from './apiClient';

const canvasAPI = {
  getCanvasContent: async (canvasId: string) => {
    return handleApiRequest<string>(
      axiosInstance.get(`/canvas/${canvasId}`),
    );
  }
};

export default canvasAPI;
